import React from 'react';
import s from './Cart.module.css';

type Props = {
	number: string;
	title: string;
};
const TopCardElement = ({number, title}: Props) => {
	return (
		<div className={s.buyerTitle}>
			<div className={s.numberBox}>{number}</div>
			<div className={s.buyerTitle}>{title}</div>
		</div>
	);
};

export default TopCardElement;
